/*
 * @Description: 交叉分析拖动组件配置
 * @Version: 1.0
 * @Autor: jinchuan.lee
 * @Date: 2021-06-01 10:47:59
 * @LastEditors: jinchuan.lee
 * @LastEditTime: 2021-06-02 14:15:30
 */
const getDragConfig = (type) => {
    let group = {
        name: "menu", //多项拖动统一名字
        animation: 150,  // ms, 动画速度运动项目排序时，' 0 ' -没有动画。
        put: true,   // 是否允许拖入
        sort:true,  // 是否允许排序
        dragClass: "sortable-drag",  // 拖动class
        chosenClass:"sortable-chosen",  //  选中class
        ghostClass: "",  // 设置拖动元素的class的占位符的类名。
    }
    if(type==="1") {
        group = Object.assign(group,{
            put: false,
            sort:false,
            pull:'clone'
        })
    }else if(type==="2") {
        group = Object.assign(group,{
            ghostClass: "sortable-ghost",
        })
    }else if(type==="3") {
        group = Object.assign(group,{
            ghostClass: "sortable-ghosts",
            sort:false,
        })
    }
    return group;
}
export default {
    getDragConfig
}


// WEBPACK FOOTER //
// ./src/pages/cashier/components/crossAnalysis/dragConfig.js